import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { TooltipProvider } from '@/components/ui/basicos';
import { ProvedorDeServicos, type Servicos } from '@/lib/servicos';

interface Props {
  servicos: Servicos;
  queryClient: QueryClient;
  children: ReactNode;
}

export function Providers({ servicos, queryClient, children }: Props) {
  return (
    <ProvedorDeServicos servicos={servicos}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={300}>{children}</TooltipProvider>
      </QueryClientProvider>
    </ProvedorDeServicos>
  );
}
